const YIP = [
  {
    id: "6",
    year: "2024",
    yearS: "25",
    icon: "tim-icons icon-bulb-63 text-success pr-1",
    school: "800",
    student: "1400",
    teams: "32",
    idFirst: "2024-first",
    idSecond: "2024-second",
    idThird: "2024-third"
  },
  {
    id: "5",
    year: "2023",
    yearS: "24",
    icon: "tim-icons icon-bulb-63 text-success pr-1",
    school: "700",
    student: "1400",
    teams: "32",
    idFirst: "2023-first",
    idSecond: "2023-second",
    idThird: "2023-third"
  },
  {
    id: "4",
    year: "2022",
    yearS: "23",
    icon: "tim-icons icon-bulb-63 text-success pr-1",
    school: "650",
    student: "1400",
    teams: "32",
    idFirst: "2022-first",
    idSecond: "2022-second",
    idThird: "2022-third"
  },
    {
      id: "1",
      year: "2019",
      yearS: "20",
      icon: "tim-icons icon-spaceship text-success pr-1",
      school: "1200",
      student: "2400",
      teams: "32",
      idFirst: "2019-first",
      idSecond: "2019-second",
      idThird: "2019-third"
    },
    {
      id: "2",
      year: "2018",
      yearS: "19",
      icon: "tim-icons icon-shape-star text-success pr-1",
      school: "1000",
      student: "1000",
      teams: "24",
      idFirst: "2018-first",
      idSecond: "2018-second",
      idThird: "2018-third"
    },
    {
      id: "3",
      year: "2017",
      yearS: "18",
      icon: "tim-icons icon-bulb-63 text-success pr-1",
      school: "200",
      student: "400",
      teams: "6",
      idFirst: "2017-first",
      idSecond: "2017-second",
      idThird: "2017-third"
    }
    
  ];
  //YIP.map((item) => console.log(item.year));
  
  export default YIP;
  